var _path, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgFullScreen(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "current",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0.5 2.16667V5.5H2.16667V2.16667H5.5V0.5H2.16667C1.25 0.5 0.5 1.25 0.5 2.16667ZM2.16667 10.5H0.5V13.8333C0.5 14.75 1.25 15.5 2.16667 15.5H5.5V13.8333H2.16667V10.5ZM13.8333 13.8333H10.5V15.5H13.8333C14.75 15.5 15.5 14.75 15.5 13.8333V10.5H13.8333V13.8333ZM13.8333 0.5H10.5V2.16667H13.8333V5.5H15.5V2.16667C15.5 1.25 14.75 0.5 13.8333 0.5Z",
    fill: "current"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_135_137",
    x1: -5.04167,
    y1: -7.82031,
    x2: 2.6583,
    y2: 17.3638,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#E20613"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#EE7B5A"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFullScreen);
export default __webpack_public_path__ + "static/media/fullScreen.da2bc725.svg";
export { ForwardRef as ReactComponent };